import React from 'react';
import { t } from 'Src/i18n';
import { Prices } from './prices/Prices';
export const INSTALMENT_LOCALES = ['pt-BR', 'es-AR'];
export type PriceProps = {
  bestPrice?: FormattedPrice;
  className?: string;
  color?: Colors;
  from?: Node;
  hasAsterisk?: boolean;
  hasInitialPrice?: boolean;
  isOnLastPage?: boolean;
  hasTotalPrice?: boolean;
  hasInstalment?: boolean;
  hasTaxesAndFeesIncludedLabel?: boolean;
  initialPrice?: FormattedPrice;
  isLoading?: boolean;
  theme?: string;
  unit?: string;
  viewRates?: string;
  displayInstalment?: boolean;
};
export const Price = ({ isOnLastPage, displayInstalment, ...props }: PriceProps) => {
  return (
    <Prices
      {...props}
      hasInstalment={displayInstalment}
      unit={displayInstalment ? t('common.price.instalmentWithFees') : props.unit}
    />
  );
};
